import React, { memo, useEffect, useRef, useState } from "react";
import "./productCard.css";

function ReusableProductCard({
  cardsData = [],
  backgroundColor = "#8ddec9",
  intervalTime = 3000,
  maxVisibleCards = 4,
}) {
  const [displayCards, setDisplayCards] = useState([]);
  const wrapperRef = useRef(null);
  const cardHeightRef = useRef(0);
  const animatingRef = useRef(false);
  const transitionTimeMs = 800;

  // Generate 8 cards (4 visible + 4 below)
  const generateCards = (startIndex = 0) => {
    const cards = [];
    for (let i = 0; i < maxVisibleCards * 2; i++) {
      const cardIndex = (startIndex + i) % cardsData.length;
      cards.push({
        ...cardsData[cardIndex],
        key: `${startIndex}-${i}-${cardIndex}`,
      });
    }
    return cards;
  };

  useEffect(() => {
    if (cardsData.length === 0) return;
    setDisplayCards(generateCards(0));

    // calculate card height precisely
    setTimeout(() => {
      const wrapper = wrapperRef.current;
      if (!wrapper) return;
      const firstCard = wrapper.querySelector(".product-action-product-card");
      if (firstCard) {
        const style = getComputedStyle(wrapper);
        const gap = parseFloat(style.rowGap || style.gap || 0);
        const height = firstCard.offsetHeight;
        cardHeightRef.current = height + gap;
      }
    }, 100);
  }, [cardsData, maxVisibleCards]);

  // Run the infinite upward animation
  useEffect(() => {
    if (cardsData.length === 0) return;
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const scrollUp = () => {
      if (animatingRef.current) return;
      animatingRef.current = true;

      const step = cardHeightRef.current * maxVisibleCards;
      wrapper.style.transition = `transform ${transitionTimeMs}ms cubic-bezier(0.4, 0, 0.2, 1)`;
      wrapper.style.transform = `translateY(-${step}px)`;

      const handleTransitionEnd = () => {
        wrapper.removeEventListener("transitionend", handleTransitionEnd);
        wrapper.style.transition = "none";
        wrapper.style.transform = "translateY(0)";
        setDisplayCards((prev) => {
          const moved = prev.slice(0, maxVisibleCards);
          const rest = prev.slice(maxVisibleCards);
          return [...rest, ...moved];
        });
        animatingRef.current = false;
      };
      wrapper.addEventListener("transitionend", handleTransitionEnd);
    };

    const interval = setInterval(scrollUp, intervalTime);
    return () => clearInterval(interval);
  }, [intervalTime, cardsData.length, maxVisibleCards]);

  return (
    <div style={{ padding: "0rem 2.5rem", overflow: "hidden" }}>
      <div className="phone-screen" style={{ backgroundColor }}>
        <div className="product-action-cards-container">
          <div ref={wrapperRef} className="cards-wrapper">
            {displayCards.map((card) => (
              <Card key={card.key} content={card} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(ReusableProductCard);

const Card = memo(({ content }) => (
  <div className="product-action-product-card">
    <img
      src={content.imgUrl}
      alt={content.apiName}
      className="product-scroll-card-image"
      loading="lazy"
      decoding="async"
    />
    <div className="product-scroll-card-content">
      <div className="product-scroll-card-box">
        <span className="product-scroll-card-highlight">{content.apiName}</span>
        <h3 className="product-scroll-card-heading">{content.successMsg}</h3>
      </div>
    </div>
  </div>
));
